import script from "./Dashbord.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dashbord.vue?vue&type=script&setup=true&lang=ts"

import "./Dashbord.vue?vue&type=style&index=0&id=39609192&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39609192"]])

export default __exports__